import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getSubmissionListApi,
  getSubmissionDetailsApi,
  moveToDraftApi,
} from "../api/submissionsApi";
import { errorMessage, successMessage } from "../../../utils";

// Query key factory for Submissions module
export const submissionKeys = {
  all: ["submissions"],
  lists: () => [...submissionKeys.all, "list"],
  detail: (id) => [...submissionKeys.lists(), id],
};

export const useSubmissionQueries = ({ listParams = {} } = {}) => {
  const submissionListQuery = useQuery({
    queryKey: [submissionKeys.lists(), listParams],
    queryFn: async () => await getSubmissionListApi(listParams),
    select: (data) => data?.data,
  });
  return { submissionListQuery };
};

export const useSubmissionDetailQuery = (id) => {
  const queryClient = useQueryClient();

  const submissionDetailQuery = useQuery({
    queryKey: submissionKeys.detail(id),
    queryFn: async () => await getSubmissionDetailsApi(id),
    select: (data) => data?.data,
    enabled: !!id,
  });

  const moveToDraftMutation = useMutation({
    mutationFn: () => moveToDraftApi(id),
    onSuccess: () => {
      successMessage("Submission moved to draft");
      queryClient.invalidateQueries({ queryKey: submissionKeys.detail(id) });
    },
    onError: (error) => {
      errorMessage(error?.response?.data || "Failed to move to draft");
    },
  });

  return { submissionDetailQuery, moveToDraftMutation };
};
